/*
 * File: Visuals.tsx
 * Project: autobuy-back-office
 * File Created: Friday, 4th August 2023 12:15:58
 * Author: Simon (s.gourlet@autobuy.fr)
 * -----
 * Last Modified: Tuesday, 5th September 2023 09:27:19
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright 2022 - 2023 SAS Olivier Dubois, SAS Olivier Dubois
 */

import {useEffect, useState} from "react";
import translator from "MultiLanguage/TranslationWrapper";
import { useLoaderData } from "react-router-dom";
import CollectionVisuals from "./Collection/Collection";
import TitlePage from "Content/HeadingPage/TitlePage/TitlePage";
import { CollectionProps } from "Type/visuals.type";
import ModalVisual from "Content/Modals/ModalVisual/ModalVisual";
import Styles from "Content/Visuals/Visuals.module.css";
import { Button } from "react-bootstrap";
import ModalCollection from "Content/Modals/ModalCollection/ModalCollection";
import CollectionService from "Services/Visuals/Collection/CollectionService";

function Visuals() {
    const loadData = useLoaderData() as {id: string, Name: string}[];
    const visualTitle = translator.decode("visuals.titles.title");
    const [collections, setCollections] = useState<{id: string, Name: string}[]>([]);
    const [showModalCollection, setShowModalCollection] = useState(false);
    const [ShowVisualModal, setShowVisualModal] = useState(false);

    useEffect(() => {
        setCollections(loadData);
    }, [loadData])

    const refreshCollections = () => {
        CollectionService.getCollectionsName().then((refreshedCollections) => {
            setCollections(refreshedCollections);
        });
    }

    return (
        <div className="p-3">
            <TitlePage title={visualTitle} action={
                <div className={`${Styles.buttonGroup}`}>
                    <Button onClick={() => setShowModalCollection(true)}>{translator.decode("collections.titles.collectionCreation")}</Button>
                    <Button onClick={() => setShowVisualModal(true)}>{translator.decode("visuals.titles.visualCreation")}</Button>
                </div>
            } />
            {
                collections.map((item) => (
                    <CollectionVisuals key={item.id} name={item.Name} onCollectionDelete={refreshCollections} />
                ))
            }
            <ModalVisual title={translator.decode("visuals.modal.title")} show={ShowVisualModal} onClose={() => setShowVisualModal(false)} closeModal={() => setShowVisualModal(false)} collections={collections} />
            <ModalCollection title={translator.decode("collections.modal.title")} show={showModalCollection} onClose={() => setShowModalCollection(false)} closeModal={() => setShowModalCollection(false)} onCollectionCreated={refreshCollections} />
        </div>
    )
}

export default Visuals
